export default __webpack_public_path__ + "static/media/Background_00240.78f67a2a.png";